import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { CurrentUser } from "../../../common/models/user";
import { NotificationService } from "../../../common/services/notification.service";
import { SearchService } from "../../../common/services/search.service";
import { StorageService } from "../../../common/services/storage.service";
import { CustomizerSettingsService } from "../../../customizer-settings/customizer-settings.service";
import { Subject, takeUntil } from 'rxjs';
import { GetAllNotificationsForUserFilter, NotificationForUser } from "../../../common/models/notification";
import { NotificationsFilterBuilder } from "../../../common/components/filter/builders/notifications-filter-builder";
import { FilterService } from "../../../common/components/filter/services/filter.service";


@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.scss',
    imports: [MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatIconModule,
        CommonModule
    ]
})
export class NotificationsComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    notifications: NotificationForUser[] = [];
    filteredNotifications: NotificationForUser[] = [];
    user: CurrentUser | null = null;
  
    isToggled = false;
  
    constructor(
      private router: Router,
      private notificationService: NotificationService,
      private filterBuilder: NotificationsFilterBuilder,
      private storageService: StorageService,
      private searchService: SearchService,
      private filterService: FilterService,
      public themeService: CustomizerSettingsService,
    ) {}
  
    ngOnInit() {
      this.themeService.isToggled$.pipe(takeUntil(this.destroy$)).subscribe(isToggled => {
        this.isToggled = isToggled;
      });
      this.searchService.currentSearchTerm$.pipe(takeUntil(this.destroy$)).subscribe(term => {
        this.applySearch(term);
      });
      this.filterService.filterChanges$.pipe(takeUntil(this.destroy$)).subscribe((filters) => {
        this.filterService.setFiltersInScope(filters);
        this.fetchNotifications();
      });
       this.storageService.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
        this.user = user;
        this.initializeFilters();
      });
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }

     initializeFilters(): void {
      const startYear = 2025;
      const currentYear = new Date().getFullYear();
    
      const config = this.filterBuilder
        .reset()
        .years(startYear)
        .build();

      this.filterService.setFilterConfig(config);
      this.filterService.restoreFiltersInScope({ year: currentYear });    
      
    }
  
    fetchNotifications(): void { 
      const savedFilterValues = this.filterService.getFiltersInScope();
              
      const filter = new GetAllNotificationsForUserFilter(
        this.user?.id,
        savedFilterValues?.year
      );

      this.notificationService.getNotificationsForUser(filter).pipe(takeUntil(this.destroy$)).subscribe({
        next: (data) => {
          this.notifications = data;
          this.filteredNotifications = data;
        },
        error: (error) => {
          console.error('Error fetching notifications', error);
        }
      });
    }

    applySearch(searchTerm: string): void {
      searchTerm = searchTerm.trim().toLowerCase();
      if (searchTerm) {
        this.filteredNotifications = this.notifications.filter((notification: NotificationForUser) => {
          return (
            notification.title.toLowerCase().includes(searchTerm) ||
            notification.message.toLowerCase().includes(searchTerm)
          );
        });
      } else {
        this.filteredNotifications = [...this.notifications];
      }
    }

    viewNotification(notification: NotificationForUser) {
      this.router.navigate(['association', 'notifications', notification.id, 'view'], {
        state: { notification: notification },
      });
    }
}